import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { useDebouncedMemo } from '@hooks/debounceAsync';
import {
  buildSuggestionParams,
  type SuggestionFilter,
} from '../lib/suggestion-params';
import { catalogMappingKeys } from '../lib/query-keys';
import { getMappingSuggestions } from '../lib/suggestions-api';
import type {
  MappingSuggestionRow,
  SuggestionView,
} from '../lib/suggestion-types';

const noRows: MappingSuggestionRow[] = [];

/* One queue of the Mapping tab, a page at a time. */
export function useMappingSuggestions(
  view: SuggestionView,
  filter: SuggestionFilter,
) {
  /* Typing in the search box asks once it settles, not on every key. */
  const search = useDebouncedMemo<string>(
    () => filter.search,
    [filter.search],
    500,
    filter.search,
  );
  const params = buildSuggestionParams(view, {
    ...filter,
    search: search ?? '',
  });

  const query = useQuery({
    queryKey: catalogMappingKeys.suggestions(params),
    queryFn: () => getMappingSuggestions(params),
    placeholderData: keepPreviousData,
  });

  return {
    rows: query.data?.data ?? noRows,
    loading: query.isPending,
    error: query.error,
    total: query.data?.total_data ?? 0,
  };
}
